import { useState, useEffect } from "react";

export const useTimezone = () => {
  const [timezone, setTimezone] = useState<string>(
    Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"
  );

  useEffect(() => {
    // Get user's timezone
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezone(userTimezone);
  }, []);

  const formatInTimezone = (date: Date | string, format: string = "PPP p") => {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return dateObj.toLocaleString("en-US", {
      timeZone: timezone,
      ...getFormatOptions(format),
    });
  };

  const toUserTimezone = (utcDate: Date | string): Date => {
    const dateObj = typeof utcDate === "string" ? new Date(utcDate) : utcDate;
    return new Date(dateObj.toLocaleString("en-US", { timeZone: timezone }));
  };

  const toUTC = (localDate: Date): Date => {
    return new Date(localDate.toISOString());
  };

  return {
    timezone,
    formatInTimezone,
    toUserTimezone,
    toUTC,
  };
};

const getFormatOptions = (format: string): Intl.DateTimeFormatOptions => {
  // Simple format mapping
  const options: Intl.DateTimeFormatOptions = {};
  
  if (format.includes("P")) {
    options.year = "numeric";
    options.month = "long";
    options.day = "numeric";
  }
  
  if (format.includes("p")) {
    options.hour = "numeric";
    options.minute = "2-digit";
    options.hour12 = true;
  }
  
  return options;
};
